import { RootState } from "state/delegate";

export const welcomeOnboardingOfferSelectors = {
  getWelcomeOnboardingOffer: (state: RootState) =>
    state.welcomeOnboardingOffer.data,
};
